'use client';

import React, { useState, useRef, useEffect } from 'react';
import { useTranslations } from "next-intl"
import { IoMdCloseCircle } from "react-icons/io";
import {useLocale} from 'next-intl';
import { TbRulerMeasure } from "react-icons/tb";

const SizeMeasurment: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dialogRef = useRef<HTMLDivElement>(null); // Ref for the dialog container
  const t = useTranslations('Shop-id');
  const l = useLocale();
 



 
  // Close the dialog when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dialogRef.current && !dialogRef.current.contains(event.target as Node)) {
        setIsOpen(false); // Close the dialog
      }
    };

    // Add event listener when the dialog is open
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Cleanup the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]); // Re-run effect when `isOpen` changes

  return (
    <>
      {/* Button to open the dialog */}
      <div className='flex gap-2 cursor-pointer text-gray-600 items-center' onClick={() => setIsOpen(true)}>
        <TbRulerMeasure/>
      <p className='underline'>{t('size')}</p>
      </div>

      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 text-gray-600">
          <div
            ref={dialogRef} // Attach the ref to the dialog container
            className="bg-white rounded-lg shadow-lg px-6   max-w-6xl w-full relative "
          >
            {/* Close Button */}
            {l === "ar"? (
              <IoMdCloseCircle size={24} className="absolute top-3 left-3 text-gray-500 hover:text-gray-700" onClick={() => setIsOpen(false)}/>
            ) : (
              <IoMdCloseCircle size={24} className="absolute top-3 right-3 text-gray-500 hover:text-gray-700" onClick={() => setIsOpen(false)}/>
            )}
            
            {/* Content */}
           
            <div>
      {/* Clothing Size Table */}
      <div className=" max-h-[70vh] overflow-y-auto ">
      {/* Men's Clothing Size Table */}
      <div className="mb-12 ">
        <h2 className="text-2xl font-bold mb-4 pt-12">{t('title1')}</h2>
        <h3 className="text-xl font-semibold mb-2">{t('sub1-title1')}</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-200">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-4 py-2 border">US</th>
                <th className="px-4 py-2 border">UK</th>
                <th className="px-4 py-2 border">EU</th>
                <th className="px-4 py-2 border">{t('China')}</th>
                <th className="px-4 py-2 border">{t('Chesti')}</th>
                <th className="px-4 py-2 border">{t('Chestc')}</th>
                <th className="px-4 py-2 border">{t('Waisti')}</th>
                <th className="px-4 py-2 border">{t('Waistc')}</th>
              </tr>
            </thead>
            <tbody>
              {[
                { US: 'XS', UK: '32', EU: '44', China: '165/84A', ChestIn: '34-36', ChestCm: '86-91', WaistIn: '28-30', WaistCm: '71-76' },
                { US: 'S', UK: '34', EU: '46', China: '170/88A', ChestIn: '36-38', ChestCm: '91-97', WaistIn: '30-32', WaistCm: '76-81' },
                { US: 'M', UK: '38', EU: '48', China: '175/92A', ChestIn: '38-40', ChestCm: '97-102', WaistIn: '32-34', WaistCm: '81-86' },
                { US: 'L', UK: '40', EU: '50', China: '180/96A', ChestIn: '40-42', ChestCm: '102-107', WaistIn: '34-36', WaistCm: '86-91' },
                { US: 'XL', UK: '42', EU: '52', China: '185/100A', ChestIn: '42-44', ChestCm: '107-112', WaistIn: '36-38', WaistCm: '91-97' },
                { US: 'XXL', UK: '44', EU: '54', China: '190/104A', ChestIn: '44-46', ChestCm: '112-117', WaistIn: '38-40', WaistCm: '97-102' },
              ].map((row, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-4 py-2 border text-center">{row.US}</td>
                  <td className="px-4 py-2 border text-center">{row.UK}</td>
                  <td className="px-4 py-2 border text-center">{row.EU}</td>
                  <td className="px-4 py-2 border text-center">{row.China}</td>
                  <td className="px-4 py-2 border text-center">{row.ChestIn}</td>
                  <td className="px-4 py-2 border text-center">{row.ChestCm}</td>
                  <td className="px-4 py-2 border text-center">{row.WaistIn}</td>
                  <td className="px-4 py-2 border text-center">{row.WaistCm}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Women's Clothing Size Table */}
      <div className="mb-12">
        <h3 className="text-xl font-semibold mb-2">{t('sub2-title1')}</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-200">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-4 py-2 border">US</th>
                <th className="px-4 py-2 border">UK</th>
                <th className="px-4 py-2 border">EU</th>
                <th className="px-4 py-2 border">{t('China')}</th>
                <th className="px-4 py-2 border">{t('Busti')}</th>
                <th className="px-4 py-2 border">{t('Bustc')}</th>
                <th className="px-4 py-2 border">{t('Waisti')}</th>
                <th className="px-4 py-2 border">{t('Waistc')}</th>
                <th className="px-4 py-2 border">{t('Hipsi')}</th>
                <th className="px-4 py-2 border">{t('Hipsc')}</th>
              </tr>
            </thead>
            <tbody>
              {[
                { US: 'XS', UK: '6', EU: '34', China: '155/80A', BustIn: '32-33', BustCm: '81-84', WaistIn: '24-25', WaistCm: '61-64', HipsIn: '34-35', HipsCm: '86-89' },
                { US: 'S', UK: '8', EU: '36', China: '160/84A', BustIn: '34-35', BustCm: '86-89', WaistIn: '26-27', WaistCm: '66-69', HipsIn: '36-37', HipsCm: '91-94' },
                { US: 'M', UK: '10', EU: '38', China: '165/88A', BustIn: '36-37', BustCm: '91-94', WaistIn: '28-29', WaistCm: '71-74', HipsIn: '38-39', HipsCm: '97-99' },
                { US: 'L', UK: '12', EU: '40', China: '170/92A', BustIn: '38-39', BustCm: '97-99', WaistIn: '30-31', WaistCm: '76-79', HipsIn: '40-41', HipsCm: '102-104' },
                { US: 'XL', UK: '14', EU: '42', China: '175/96A', BustIn: '40-41', BustCm: '102-104', WaistIn: '32-33', WaistCm: '81-84', HipsIn: '42-43', HipsCm: '107-109' },
                { US: 'XXL', UK: '16', EU: '44', China: '180/100A', BustIn: '42-43', BustCm: '107-109', WaistIn: '34-35', WaistCm: '86-89', HipsIn: '44-45', HipsCm: '112-114' },
              ].map((row, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-4 py-2 border text-center">{row.US}</td>
                  <td className="px-4 py-2 border text-center">{row.UK}</td>
                  <td className="px-4 py-2 border text-center">{row.EU}</td>
                  <td className="px-4 py-2 border text-center">{row.China}</td>
                  <td className="px-4 py-2 border text-center">{row.BustIn}</td>
                  <td className="px-4 py-2 border text-center">{row.BustCm}</td>
                  <td className="px-4 py-2 border text-center">{row.WaistIn}</td>
                  <td className="px-4 py-2 border text-center">{row.WaistCm}</td>
                  <td className="px-4 py-2 border text-center">{row.HipsIn}</td>
                  <td className="px-4 py-2 border text-center">{row.HipsCm}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Children's Clothing Size Table */}
      <div className="mb-12">
        <h3 className="text-xl font-semibold mb-2">{t('sub3-title1')}</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-200">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-4 py-2 border">{t('Age')}</th>
                <th className="px-4 py-2 border">US</th>
                <th className="px-4 py-2 border">UK</th>
                <th className="px-4 py-2 border">EU</th>
                <th className="px-4 py-2 border">{t('China')}</th>
                <th className="px-4 py-2 border">{t('Heighti')}</th>
                <th className="px-4 py-2 border">{t('Heightc')}</th>
                <th className="px-4 py-2 border">{t('Chesti')}</th>
                <th className="px-4 py-2 border">{t('Chestc')}</th>
              </tr>
            </thead>
            <tbody>
              {[
                { Age: '2-3Y', US: '2T', UK: '2', EU: '92', China: '90', HeightIn: '33-36', HeightCm: '84-91', ChestIn: '21-22', ChestCm: '53-56' },
                { Age: '4-5Y', US: '4T', UK: '4', EU: '104', China: '100', HeightIn: '37-40', HeightCm: '94-102', ChestIn: '23-24', ChestCm: '58-61' },
                { Age: '6-7Y', US: '6', UK: '6', EU: '116', China: '110', HeightIn: '41-44', HeightCm: '104-112', ChestIn: '25-26', ChestCm: '63-66' },
                { Age: '8-9Y', US: '8', UK: '8', EU: '128', China: '120', HeightIn: '45-48', HeightCm: '114-122', ChestIn: '27-28', ChestCm: '68-71' },
                { Age: '10-12Y', US: '10', UK: '10', EU: '140', China: '130', HeightIn: '49-52', HeightCm: '124-132', ChestIn: '29-30', ChestCm: '73-76' },
              ].map((row, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-4 py-2 border text-center">{row.Age}</td>
                  <td className="px-4 py-2 border text-center">{row.US}</td>
                  <td className="px-4 py-2 border text-center">{row.UK}</td>
                  <td className="px-4 py-2 border text-center">{row.EU}</td>
                  <td className="px-4 py-2 border text-center">{row.China}</td>
                  <td className="px-4 py-2 border text-center">{row.HeightIn}</td>
                  <td className="px-4 py-2 border text-center">{row.HeightCm}</td>
                  <td className="px-4 py-2 border text-center">{row.ChestIn}</td>
                  <td className="px-4 py-2 border text-center">{row.ChestCm}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Men's Footwear Size Table */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-4">{t('title2')}</h2>
        <h3 className="text-xl font-semibold mb-2">{t('sub1-title2')}</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-200">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-4 py-2 border">US</th>
                <th className="px-4 py-2 border">UK</th>
                <th className="px-4 py-2 border">EU</th>
                <th className="px-4 py-2 border">{t('China')}</th>
                <th className="px-4 py-2 border">{t('Japan')}</th>
                <th className="px-4 py-2 border">{t('Foot-Length-i')}</th>
                <th className="px-4 py-2 border">{t('Foot-Length-c')}</th>
              </tr>
            </thead>
            <tbody>
              {[
                { US: '6', UK: '5.5', EU: '39', China: '39', Japan: '24.5', FootIn: '9.25', FootCm: '23.5' },
                { US: '7', UK: '6.5', EU: '40', China: '40', Japan: '25.5', FootIn: '9.5', FootCm: '24.1' },
                { US: '8', UK: '7.5', EU: '41', China: '41', Japan: '26.5', FootIn: '9.75', FootCm: '24.8' },
                { US: '9', UK: '8.5', EU: '42', China: '42', Japan: '27.5', FootIn: '10', FootCm: '25.4' },
                { US: '10', UK: '9.5', EU: '43', China: '43', Japan: '28.5', FootIn: '10.25', FootCm: '26.0' },
                { US: '11', UK: '10.5', EU: '44', China: '44', Japan: '29.5', FootIn: '10.5', FootCm: '26.7' },
                { US: '12', UK: '11.5', EU: '45', China: '45', Japan: '30.5', FootIn: '10.75', FootCm: '27.3' },
              ].map((row, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-4 py-2 border text-center">{row.US}</td>
                  <td className="px-4 py-2 border text-center">{row.UK}</td>
                  <td className="px-4 py-2 border text-center">{row.EU}</td>
                  <td className="px-4 py-2 border text-center">{row.China}</td>
                  <td className="px-4 py-2 border text-center">{row.Japan}</td>
                  <td className="px-4 py-2 border text-center">{row.FootIn}</td>
                  <td className="px-4 py-2 border text-center">{row.FootCm}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Women's Footwear Size Table */}
      <div className="mb-12">
        <h3 className="text-xl font-semibold mb-2">{t('sub2-title2')}</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-200">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-4 py-2 border">US</th>
                <th className="px-4 py-2 border">UK</th>
                <th className="px-4 py-2 border">EU</th>
                <th className="px-4 py-2 border">{t('China')}</th>
                <th className="px-4 py-2 border">{t('Japan')}</th>
                <th className="px-4 py-2 border">{t('Foot-Length-i')}</th>
                <th className="px-4 py-2 border">{t('Foot-Length-c')}</th>
              </tr>
            </thead>
            <tbody>
              {[
                { US: '5', UK: '3.5', EU: '36', China: '36', Japan: '22.5', FootIn: '8.75', FootCm: '22.2' },
                { US: '6', UK: '4.5', EU: '37', China: '37', Japan: '23.5', FootIn: '9', FootCm: '22.9' },
                { US: '7', UK: '5.5', EU: '38', China: '38', Japan: '24.5', FootIn: '9.25', FootCm: '23.5' },
                { US: '8', UK: '6.5', EU: '39', China: '39', Japan: '25.5', FootIn: '9.5', FootCm: '24.1' },
                { US: '9', UK: '7.5', EU: '40', China: '40', Japan: '26.5', FootIn: '9.75', FootCm: '24.8' },
                { US: '10', UK: '8.5', EU: '41', China: '41', Japan: '27.5', FootIn: '10', FootCm: '25.4' },
                { US: '11', UK: '9.5', EU: '42', China: '42', Japan: '28.5', FootIn: '10.25', FootCm: '26.0' },
              ].map((row, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-4 py-2 border text-center">{row.US}</td>
                  <td className="px-4 py-2 border text-center">{row.UK}</td>
                  <td className="px-4 py-2 border text-center">{row.EU}</td>
                  <td className="px-4 py-2 border text-center">{row.China}</td>
                  <td className="px-4 py-2 border text-center">{row.Japan}</td>
                  <td className="px-4 py-2 border text-center">{row.FootIn}</td>
                  <td className="px-4 py-2 border text-center">{row.FootCm}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Children's Footwear Size Table */}
      <div>
        <h3 className="text-xl font-semibold mb-2">{t('sub3-title2')}</h3>
        <div className="overflow-x-auto mb-12">
          <table className="min-w-full bg-white border border-gray-200">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-4 py-2 border">US</th>
                <th className="px-4 py-2 border">UK</th>
                <th className="px-4 py-2 border">EU</th>
                <th className="px-4 py-2 border">{t('China')}</th>
                <th className="px-4 py-2 border">{t('Japan')}</th>
                <th className="px-4 py-2 border">{t('Foot-Length-i')}</th>
                <th className="px-4 py-2 border">{t('Foot-Length-c')}</th>
              </tr>
            </thead>
            <tbody>
              {[
                { US: '10C', UK: '9.5', EU: '27', China: '27', Japan: '16.5', FootIn: '6.5', FootCm: '16.5' },
                { US: '11C', UK: '10.5', EU: '28', China: '28', Japan: '17.5', FootIn: '6.75', FootCm: '17.1' },
                { US: '12C', UK: '11.5', EU: '29', China: '29', Japan: '18.5', FootIn: '7', FootCm: '17.8' },
                { US: '13C', UK: '12.5', EU: '30', China: '30', Japan: '19.5', FootIn: '7.25', FootCm: '18.4' },
                { US: '1Y', UK: '13', EU: '31', China: '31', Japan: '20.5', FootIn: '7.5', FootCm: '19.1' },
                { US: '2Y', UK: '1', EU: '32', China: '32', Japan: '21.5', FootIn: '7.75', FootCm: '19.7' },
                { US: '3Y', UK: '2', EU: '33', China: '33', Japan: '22.5', FootIn: '8', FootCm: '20.3' },
              ].map((row, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-4 py-2 border text-center">{row.US}</td>
                  <td className="px-4 py-2 border text-center">{row.UK}</td>
                  <td className="px-4 py-2 border text-center">{row.EU}</td>
                  <td className="px-4 py-2 border text-center">{row.China}</td>
                  <td className="px-4 py-2 border text-center">{row.Japan}</td>
                  <td className="px-4 py-2 border text-center">{row.FootIn}</td>
                  <td className="px-4 py-2 border text-center">{row.FootCm}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      </div>
      </div>
      </div>
        </div>
      )}
    </>
  );
};

export default SizeMeasurment;